"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPages = exports.getIconProps = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _isLogin = require("../constants/isLogin");

var _menu = require("../constants/menu");

var getIconProps = function getIconProps(page, _ref) {
  var isLogin = _ref.isLogin;
  return !(page.action === 8 && isLogin !== _isLogin.NOTLOGIN) ? {
    image: page.image,
    imagePosition: page.imagePosition
  } : {
    image: page.image || {
      __typename: 'DefaultIcon',
      icon: 'PERSON'
    },
    imagePosition: !page.title ? 'ONLY' : page.imagePosition
  };
};

exports.getIconProps = getIconProps;

var getPages = function getPages(page, _ref2) {
  var _user$store, _user$store$setting, _user$store2, _user$store2$setting;

  var user = _ref2.user,
      isLogin = _ref2.isLogin,
      hasStoreAppPlugin = _ref2.hasStoreAppPlugin;
  var action = page.action,
      pages = page.pages;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.CART:
      return [];

    case _menu.MENU_ACTION_TYPES.LOCALE:
      return ((user === null || user === void 0 ? void 0 : (_user$store = user.store) === null || _user$store === void 0 ? void 0 : (_user$store$setting = _user$store.setting) === null || _user$store$setting === void 0 ? void 0 : _user$store$setting.locale) || []).map(function (locale) {
        return {
          id: locale,
          title: null,
          action: _menu.MENU_ACTION_TYPES.LOCALE
        };
      });

    case _menu.MENU_ACTION_TYPES.CURRENCY:
      return ((user === null || user === void 0 ? void 0 : (_user$store2 = user.store) === null || _user$store2 === void 0 ? void 0 : (_user$store2$setting = _user$store2.setting) === null || _user$store2$setting === void 0 ? void 0 : _user$store2$setting.currency) || []).map(function (currency) {
        return {
          id: currency,
          title: null,
          action: _menu.MENU_ACTION_TYPES.CURRENCY
        };
      });

    case _menu.MENU_ACTION_TYPES.AUTH:
      return isLogin === _isLogin.NOTLOGIN ? [] : [{
        id: 'ORDERS',
        title: null,
        action: _menu.MENU_ACTION_TYPES.LINK,
        params: {
          url: '/orders'
        }
      }, {
        id: 'SETTINGS',
        title: null,
        action: _menu.MENU_ACTION_TYPES.LINK,
        params: {
          url: '/members/settings'
        }
      }, {
        id: 'RECIPIENTS',
        title: null,
        action: _menu.MENU_ACTION_TYPES.LINK,
        params: {
          url: '/members/recipients'
        }
      }, {
        id: 'PASSWORD_CHANGE',
        title: null,
        action: _menu.MENU_ACTION_TYPES.LINK,
        params: {
          url: '/members/password-change'
        }
      }].concat((0, _toConsumableArray2["default"])(!hasStoreAppPlugin('wishList') ? [] : [{
        id: 'WISHLIST',
        title: null,
        action: _menu.MENU_ACTION_TYPES.LINK,
        params: {
          url: '/members/wishlist'
        }
      }]), [{
        id: 'REWARD_POINTS',
        title: null,
        action: _menu.MENU_ACTION_TYPES.LINK,
        params: {
          url: '/members/reward-points'
        }
      }, {
        id: 'LOGOUT',
        title: null,
        action: _menu.MENU_ACTION_TYPES.AUTH_LOGOUT
      }]);

    default:
      return pages;
  }
};

exports.getPages = getPages;